<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="toc-ttl" id="toc">Table of contents</p>
<p class="toc-tx1"><a href="#/Text/c4#title">Title Page</a></p>
<p class="toc-tx1"><a href="#/Text/c5#copy">Copyright Page</a></p>
<p class="toc-tx2" id="int1"><a href="#/Text/c9#int">Introduction</a></p>
<p class="toc-tx1" id="toc1"><a href="#/Text/c10#ch1">Jazz and the White Critic</a></p>
<p class="toc-tx1" id="toc2"><a href="#/Text/c11#ch2">Minton’s</a></p>
<p class="toc-tx1" id="toc3"><span href="#/Text/c12#ch3" title="Link target outside of Sample">The Dark Lady of the Sonnets</span></p>
<p class="toc-tx1" id="toc4"><span href="#/Text/c13#ch4" title="Link target outside of Sample">Recent Monk</span></p>
<p class="toc-tx1" id="toc5"><span href="#/Text/c14#ch5" title="Link target outside of Sample">Three Ways to Play the Saxophone</span></p>
<p class="toc-tx1" id="toc6"><span href="#/Text/c15#ch6" title="Link target outside of Sample">A Day With Roy Haynes</span></p>
<p class="toc-tx1" id="toc7"><span href="#/Text/c16#ch7" title="Link target outside of Sample">Sonny Rollins <i>(Our Man in Jazz)</i></span></p>
<p class="toc-tx1" id="toc8"><span href="#/Text/c17#ch8" title="Link target outside of Sample">A Jazz Great: John Coltrane</span></p>
<p class="toc-tx2" id="toc9"><span href="#/Text/c18#ch9" title="Link target outside of Sample">Coltrane Live at Birdland</span></p>
<p class="toc-tx1" id="toc10"><span href="#/Text/c19#ch10" title="Link target outside of Sample">The Jazz Avant-Garde</span></p>
<p class="toc-tx1" id="toc11"><span href="#/Text/c20#ch11" title="Link target outside of Sample">Introducing Wayne Shorter</span></p>
<p class="toc-tx1" id="toc12"><span href="#/Text/c21#ch12" title="Link target outside of Sample">Introducing Dennis Charles</span></p>
<p class="toc-tx1" id="toc13"><span href="#/Text/c22#ch13" title="Link target outside of Sample">New York Loft and Coffee Shop Jazz</span></p>
<p class="toc-tx1" id="toc14"><span href="#/Text/c23#ch14" title="Link target outside of Sample">Introducing Bobby Bradford</span></p>
<p class="toc-tx1" id="toc15"><span href="#/Text/c24#ch15" title="Link target outside of Sample">Present Perfect (Cecil Taylor)</span></p>
<p class="toc-tx1" id="toc16"><span href="#/Text/c25#ch16" title="Link target outside of Sample">Cecil Taylor <i>(The World of Cecil Taylor)</i></span></p>
<p class="toc-tx1" id="toc17"><span href="#/Text/c26#ch17" title="Link target outside of Sample">Apple Cores #1</span></p>
<p class="toc-tx1" id="toc18"><span href="#/Text/c27#ch18" title="Link target outside of Sample">Apple Cores #2</span></p>
<p class="toc-tx1" id="toc19"><span href="#/Text/c28#ch19" title="Link target outside of Sample">Apple Cores #3</span></p>
<p class="toc-tx1" id="toc20"><span href="#/Text/c29#ch20" title="Link target outside of Sample">Apple Cores #4</span></p>
<p class="toc-tx1" id="toc21"><span href="#/Text/c30#ch21" title="Link target outside of Sample">Apple Cores #5—The Burton Greene Affair</span></p>
<p class="toc-tx1" id="toc22"><span href="#/Text/c31#ch22" title="Link target outside of Sample">Apple Cores #6</span></p>
<p class="toc-tx1" id="toc23"><span href="#/Text/c32#ch23" title="Link target outside of Sample">New Tenor Archie Shepp Talking</span></p>
<p class="toc-tx1" id="toc24"><span href="#/Text/c33#ch24" title="Link target outside of Sample">Four for Trane (Archie Shepp)</span></p>
<p class="toc-tx1" id="toc25"><span href="#/Text/c34#ch25" title="Link target outside of Sample">Don Cherry</span></p>
<p class="hang1" id="toc26"><span href="#/Text/c35#ch26" title="Link target outside of Sample">New Black Music: A Concert in Benefit of The Black Arts Repertory Theatre/School Live</span></p>
<p class="toc-tx1" id="toc27"><span href="#/Text/c36#ch27" title="Link target outside of Sample">Sonny’s Time Now</span></p>
<p class="toc-tx2" id="toc28"><span href="#/Text/c37#ch28" title="Link target outside of Sample">The Changing Same (R&amp;B and New Black Music)</span></p>
<p class="toc-tx2" id="brief1"><span href="#/Text/c38#brief" title="Link target outside of Sample"><i>A Brief Discography of New Music</i></span></p>
<p class="toc-tx1" id="toc29"><span href="#/Text/c39#ch29" title="Link target outside of Sample">Interview with Amiri Baraka by Calvin Reid (2009)</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?00ccb3a3